import detailedRecord from '../../assets/images/icon-detailed-records.svg';
import brandRecognition from '../../assets/images/icon-brand-recognition.svg';
import fullCustomization from '../../assets/images/icon-fully-customizable.svg';

const productOfferingData = [
  {
    icon: brandRecognition,
    title:'Brand Recognition',
    description:`Boost your brand recognition with each click. Generic links don’t 
    mean a thing. Branded links help instil confidence in your content.`,
  },
  {
    icon: detailedRecord,
    title:'Detailed Records',
    description:`Gain insights into who is clicking your links. Knowing when and where 
    people engage with your content helps inform better decisions.`,
  },
  {
    icon: fullCustomization,
    title: "Fully Customizable",
    description:`Improve brand awareness and content discoverability through customizable 
    links, supercharging audience engagement.`,
  },
];

export {productOfferingData};